/**
 * Grid column switcher for collection pages.
 * Toggles md:grid-cols-N classes on the parent <collection-filters>'s
 * [data-product-grid] element and persists the user choice in
 * localStorage under "collection-grid-cols".
 */
import { Component } from "@theme/component";

class GridSwitcher extends Component {
  static STORAGE_KEY = "collection-grid-cols";

  setup() {
    this.grid = this.closest("collection-filters")?.querySelector(
      "[data-product-grid]",
    );
    this.btns = this.$$("[data-grid]");
    if (!this.grid || !this.btns.length) return;

    const saved = localStorage.getItem(GridSwitcher.STORAGE_KEY);
    if (saved) this.#apply(saved);

    this.btns.forEach((btn) =>
      btn.addEventListener("click", () => {
        const cols = btn.dataset.grid;
        this.#apply(cols);
        localStorage.setItem(GridSwitcher.STORAGE_KEY, cols);
      }),
    );
  }

  #apply(cols) {
    // Map raw cols → the actual literal Tailwind classes Tailwind v4 scans.
    // We keep both classes on the candidate list so removing one never leaves
    // the grid in a mixed state.
    const colsMap = { 3: "lg:grid-cols-3", 4: "lg:grid-cols-4" };
    Object.values(colsMap).forEach((cls) => this.grid.classList.remove(cls));
    const cls = colsMap[cols];
    if (cls) this.grid.classList.add(cls);

    this.btns.forEach((b) => {
      const active = b.dataset.grid === String(cols);
      b.classList.toggle("bg-chartreuse", active);
      b.classList.toggle("text-noir-violet", active);
      b.classList.toggle("shadow-[2px_2px_0_var(--color-ink)]", active);
      b.classList.toggle("-translate-y-0.5", active);
    });
  }
}

customElements.define("grid-switcher", GridSwitcher);

export { GridSwitcher };
